/**
 * Webhook-related enums
 * Single source of truth for webhook types across the application
 */
/**
 * HTTP methods allowed for webhook forwarding
 */
export var WebhookMethod;
(function (WebhookMethod) {
    WebhookMethod["GET"] = "GET";
    WebhookMethod["POST"] = "POST";
    WebhookMethod["PUT"] = "PUT";
    WebhookMethod["PATCH"] = "PATCH";
    WebhookMethod["DELETE"] = "DELETE";
})(WebhookMethod || (WebhookMethod = {}));
/**
 * Authentication types for outbound webhook forwarding
 */
export var WebhookAuthType;
(function (WebhookAuthType) {
    WebhookAuthType["NONE"] = "NONE";
    WebhookAuthType["BEARER"] = "BEARER";
    WebhookAuthType["JWT"] = "JWT";
})(WebhookAuthType || (WebhookAuthType = {}));
/**
 * Sources that can invoke a webhook
 */
export var WebhookSource;
(function (WebhookSource) {
    // Internal authenticated sources
    WebhookSource["USER"] = "USER";
    WebhookSource["BUSINESS"] = "BUSINESS";
    WebhookSource["TENANT"] = "TENANT";
    // System-level internal invocation (e.g., token metadata webhook fetch)
    WebhookSource["INTERNAL"] = "INTERNAL";
    // External verified sources
    WebhookSource["STRIPE"] = "STRIPE";
    // Allow any external traffic (no verification)
    WebhookSource["ANY"] = "ANY";
})(WebhookSource || (WebhookSource = {}));
/**
 * Webhook execution status
 */
export var WebhookExecutionStatus;
(function (WebhookExecutionStatus) {
    WebhookExecutionStatus["PENDING"] = "PENDING";
    WebhookExecutionStatus["SUCCESS"] = "SUCCESS";
    WebhookExecutionStatus["FAILED"] = "FAILED";
    WebhookExecutionStatus["BLOCKED"] = "BLOCKED";
})(WebhookExecutionStatus || (WebhookExecutionStatus = {}));
/**
 * Webhook callback status (from external workflow engine)
 */
export var WebhookCallbackStatus;
(function (WebhookCallbackStatus) {
    /** No callback received yet */
    WebhookCallbackStatus["NONE"] = "NONE";
    /** Workflow completed successfully */
    WebhookCallbackStatus["SUCCESS"] = "SUCCESS";
    /** Workflow failed */
    WebhookCallbackStatus["FAILED"] = "FAILED";
    /** Workflow was cancelled */
    WebhookCallbackStatus["CANCELLED"] = "CANCELLED";
})(WebhookCallbackStatus || (WebhookCallbackStatus = {}));
//# sourceMappingURL=webhook.enum.js.map